import React from "react";
import LogisticSheetPlantwiseChart from "./LogisticSheetPlantwiseChart";
import PieChart from "./PieChart";
import CommoditywiseBar from "./CommoditywiseBar";
import AnnualLogisticCost from "./AnnualLogisticCost";
import AnnualRecommendations from "./AnnualRecommendations";
import PlantWiseLogisticBarChart from "./PlantWiseLogisticBarChart";
import styles from "./MisReportsGraphs.module.scss";
import { Loader } from "../Loader";
import PercentageReturnableGraph from "./PercentageReturnableGraph";
import ReturnableExpendableCostBarChart from "./ReturnableExpendableCostBarChart";
import IncoTermwiseCostBarChart from "./IncoTermwiseCostBarChart";
import clsx from "clsx";

const MisReportGraph = ({
  plantWiseSheet,
  percentageData,
  logisticsCostData,
  annualCostData,
  annualRecommendationsData,
  countAndCostData,
  returnableExpendableCostData,
  IncoTermWiseCostData,
}) => {
  return (
    <div className={styles["main-graph-conatiner"]}>
      <div className={styles["mis-graph-div"]}>
        <div className={styles["mis-graph-single"]}>
          {plantWiseSheet?.header_array ? (
            <LogisticSheetPlantwiseChart plantWiseSheet={plantWiseSheet} />
          ) : (
            <div className={styles.chart}>
              <Loader />
            </div>
          )}
        </div>
        <div className={styles["mis-graph-single"]}>
          {annualCostData?.header_array ? (
            <AnnualLogisticCost annualCostData={annualCostData} />
          ) : (
            <div className={styles.chart}>
              <Loader />
            </div>
          )}
        </div>
      </div>
      <div className={styles["mis-graph-div"]}>
        <div className={styles["mis-graph-single"]}>
          {percentageData?.header_array ? (
            <PercentageReturnableGraph percentageData={percentageData} />
          ) : (
            <div className={styles.chart}>
              <Loader />
            </div>
          )}
        </div>
        <div className={styles["mis-graph-single"]}>
          {returnableExpendableCostData?.header_array ? (
            <ReturnableExpendableCostBarChart returnableExpendableCostData={returnableExpendableCostData} />
          ) : (
            <div className={styles.chart}>
              <Loader />
            </div>
          )}
        </div>
      </div>
      <div className={styles["mis-graph-div"]}>
        <div className={styles["mis-graph-single"]}>
          {annualRecommendationsData?.header_array ? (
            <AnnualRecommendations
              annualRecommendationsData={annualRecommendationsData}
            />
          ) : (
            <div className={styles.chart}>
              <Loader />
            </div>
          )}
        </div>
        <div className={styles["mis-graph-single"]}>
          {logisticsCostData?.header_array ? (
            <PlantWiseLogisticBarChart logisticsCostData={logisticsCostData} />
          ) : (
            <div className={styles.chart}>
              <Loader />
            </div>
          )}
        </div>
        {/* <div className={styles["mis-graph-single"]}>
          {countAndCostData?.header_array ? (
            <CommoditywiseBar countAndCostData={countAndCostData} />
          ) : (
            <div className={styles.chart}>
              {" "}
              <Loader />{" "}
            </div>
          )}
        </div> */}
      </div>
      <div className={clsx(styles["mis-graph-div"], styles["mis-graph-scroll"])}>
        <div className={styles["mis-graph-full"]}>
          {IncoTermWiseCostData?.header_array ? (
            <IncoTermwiseCostBarChart
              IncoTermWiseCostData={IncoTermWiseCostData}
            />
          ) : (
            <div className={styles.chart}>
              <Loader />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default MisReportGraph;
